import { graphql } from "~/gql";
export const UPDATE_MATTER_COLLABORATORS = graphql(/* GraphQL */ `
  mutation updateMatterCollaborators($data: UpdateMatterCollaboratorsInput!) {
    updateMatterCollaborators(data: $data) {
      id
      user {
        id
        userName
        displayName
      }
    }
  }
`);

export const UPDATE_PARENT_MATTER_COLLABORATORS = graphql(/* GraphQL */ `
  mutation updateParentMatterCollaborators($data: UpdateMatterCollaboratorsInput!) {
    updateParentMatterCollaborators(data: $data) {
      id
      user {
        id
        userName
        displayName
      }
    }
  }
`);
